/**
 * Setup comum a todas as páginas.
 *
 * - Inicializa i18n (lang do localStorage → browser → default 'en')
 * - Monta o lang picker (se container .lang-picker presente)
 * - Aplica traduções iniciais (data-i18n, data-i18n-aria, etc)
 * - Re-aplica quando idioma muda + chama callback opcional do caller
 *
 * Uso:
 *   import { setupPageShell } from '@/ui/page-setup.js';
 *   setupPageShell({ onLangChange: () => { refreshProgress(); } });
 */
import { initI18n, applyTranslations, onLangChange } from '@/i18n/index.js';
import { mountLangPicker } from '@/ui/header.js';

/**
 * @param {object} [opts]
 * @param {() => void} [opts.onLangChange] - callback chamado após re-aplicar traduções
 */
export function setupPageShell(opts = {}) {
  // 1. Detecta lang e seta <html lang>
  initI18n();

  // 2. Lang picker (header compartilhado)
  const langPicker = document.querySelector('.lang-picker');
  if (langPicker) mountLangPicker(langPicker);

  // 3. Traduções iniciais
  applyTranslations();

  // 4. Re-aplica quando idioma muda + callback do caller
  onLangChange(() => {
    applyTranslations();
    if (typeof opts.onLangChange === 'function') opts.onLangChange();
  });
}
